/* jshint esversion: 6 */

/***********************************************************************
 SequenceProfileData
 ************************************************************************
 Profile Controller Class
 ***********************************************************************/

import {Core} from "common/Core";

export function SequenceProfileData(initData) {

    const data = {
        score: 0,
        lessonStatus: "unknown",
        lessonLocation: "",
        masteryScore: 80
    };

    setData(initData);

    function getData() {
        return Core.clone(data);
    }

    function setData(newData) {

        if (!newData) {
            return;
        }

        let dataId;
        for (dataId in newData) {
            if (!newData.hasOwnProperty(dataId)) {
                continue;
            }

            switch (dataId) {
                case "score":
                    data[dataId] = formatScore(newData[dataId]);
                    break;

                case "lessonStatus":
                    data[dataId] = formatLessonStatus(newData[dataId]);
                    break;

                case "masteryScore":
                    const nValue = Number(newData[dataId]);
                    data[dataId] = isNaN(nValue) ? 0 : nValue;
                    break;

                default :
                    data[dataId] = newData[dataId];
                    break;
            }
        }
    }

    function formatScore(sScore) {

        let nScore = Number(sScore);

        if (isNaN(nScore)) {
            return (0);
        } else if (nScore < 0) {
            nScore = 0;
        } else if (nScore > 100) {
            nScore = 100;
        } else {
            nScore = Math.round(nScore);
        }

        return nScore;
    }

    function formatLessonStatus(sStatus) {

        switch (sStatus) {

            case "p":
            case "passed":
                return "p";

            case "c":
            case "completed":
                return "c";

            case "f":
            case "failed":
                return "f";

            case "i":
            case "incomplete":
                return "i";

            case "b":
            case "browsed":
                return "b";

            case "n":
            case "na":
            case "not attempted":
            case "notattempted":
            case "not_attempted":
                return "na";

            default:
        }

        return "unknown";
    }

    // revealing public api
    return {
        getData: getData,
        setData: setData
    };
}
